import React from 'react';
import LayoutWithSidebar from '../../components/layout/LayoutWithSidebar/LayoutWithSidebar';

const withSidebar = (Component, { tabsBar, singleComponent }) => {
  function ComponentWithSidebar(props) {
    return (
      <LayoutWithSidebar
        Component={Component}
        tabsBar={tabsBar}
        singleComponent={singleComponent}
        props={props}
      />
    );
  }

  return ComponentWithSidebar;
};

export default withSidebar;
